/*
* Rules Display & Filter
* author: @thinkdj | Aug 2020
* Update: 16 Feb 2021 to include FRAUD case
*/
import { Component, Input, OnInit, ViewContainerRef } from '@angular/core';

// import { default as rulesDataObj } from "./rules_sample.json";
// import { default as rulesDataObjClaims } from "./rules_sample_claims.json";
// import { default as rulesFraud } from "./demo-fraud-rules.json";
import * as  rulesDataObj from "./rules_sample.json";
import { environment } from 'environments/environment';
import { AppMetadataHandler } from 'app/BaseFramework/configs/app-metadata.handler';
import { CommonUtilty } from 'app/BaseFramework/core/utilities/commonUtility';
import { InteractService } from 'app/BaseFramework/core/services/interact/interact.service';
import { ComponentOutputDO } from 'app/BaseFramework/shared/models/common.model';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-ui-rules-auto-demo',
  templateUrl: './ui-rules-auto.component.html',
  styleUrls: ['./ui-rules-auto.component.scss']
})

export class UiRulesAutoComponent implements OnInit {

  _currentComponentName = 'UiRulesAutoComponent'
  @Input() type: 'uw' | 'claims' | 'fraud' = 'fraud';
  @Input() fraudUserType: 'adjudicator' | 'investigator' | 'adjudicator-post-investigation' = 'adjudicator';
  @Input() transactionState

  @Input() enableCategories: boolean = true;
  rulesDataCategorized = null; /* Categorized */

  constructor(public appMetadataHandler: AppMetadataHandler, private viewContainerRef: ViewContainerRef,
    private commonUtilty: CommonUtilty,private interactService: InteractService) {
  }


  ngOnInit() {
    
    
    // if(this.type === 'claims') {
    //   this.rulesData = rulesDataObjClaims;
    // }
    // else if(this.type === 'fraud') {
    //   this.rulesData = rulesFraud;this.rulesPassedCount = 14;this.rulesFailedCount = 6;
    // }
    this.subscribeToParentEvent()
    if (this.IO && this.commonUtilty.isArrayIterable(this.IO[this.nodeInIO])) {
      this.setRulesDataAndFilters();
    }

    /*DJ's code */
    if(this.enableCategories) {
      this.rulesDataCategorized =
        this.rulesData.reduce(function(h, obj) {
          h[obj.category] = (h[obj.category] || []).concat(obj);
          return h;
        }, {});
    }
  }

  /* Rules */
  rulesData: any[]  = [];
  rulesDataFiltered = [];
  rulesLoading: boolean = false;
  rulesRadio:any = "Rejected";

  /* Counts */
  //rulesPassedCount:number = this.rulesData.filter(x=>x.decisionVal.toLowerCase()=="pass").length;
  //rulesFailedCount:number = this.rulesData.filter(x=>x.decisionVal.toLowerCase()!="pass").length;
  rulesPassedCount
  rulesFailedCount

  filterRules(type?) {
    if (type === 'ALL') this.rulesDataFiltered = this.rulesData.filter(x => x.decision);
    else if(type === 'APPROVE')
     this.rulesDataFiltered = this.rulesData.filter(x => x.decision.toLowerCase() == type.toLowerCase());
     else
     this.rulesDataFiltered = this.rulesData.filter(x => x.decision.toLowerCase() != "APPROVE".toLowerCase());

    if (type) this.rulesRadio = type;
    /* Faker */
    this.pseudoLoader();
    console.log("filterRules RUN");
  }
  pseudoLoader() {
    this.rulesLoading = true;
    setTimeout(()=>{ this.rulesLoading = false },800);
  }


  /*Actuall Implementation */
  @Output() componentOutput = new EventEmitter<any>();
  
  showRules = false;
  ruleCategoryLookup = [];
  selectedIndex = 0;
  listOfCategories = [];
  searchValue = '';
  decisionCategoryLookup = [];
 
  rulesRejectCount: number = null;
  rulesReferedCount: number = null;
  insuredList = [];
  uniqueRulesFilteredList = [];

  
  _IO
@Input()
  set IO(data) {
    if (data) {
      this._IO=data 
      this.setRulesDataAndFilters();
    }
  }
  get IO(){
    return this._IO;
  }
  environment = environment
  nodeInIO = 'autoAdjResults'
  fileteRuleName

  ruleCategories = []
  private setRulesDataAndFilters() {
    // tab position set to All Rules
    this.selectedIndex = 0;
    if (environment['demo'] && (this.IO[this.nodeInIO] && Array.isArray(this.IO[this.nodeInIO]) && this.IO[this.nodeInIO].length == 0)) {
      this.rulesData = this.commonUtilty.deepCopy(rulesDataObj);
    }
    
    else if (environment['demo'] && this.appMetadataHandler.featureFlags['enableBetaFeatures']) {
      this.rulesData = this.commonUtilty.deepCopy(rulesDataObj);
    }

    /** For Production: Real rules will be rendered */
    else if (this.IO && Array.isArray(this.IO[this.nodeInIO])) {
      //this.rulesData = this.IO ? this.IO[this.nodeInIO] : [];

      let ruleData= this.IO ? this.IO[this.nodeInIO] : [];
      /*for purpose only showing non fraud rules here  */
      
      this.rulesData=ruleData.filter(x => x.ruleCategory && x.ruleCategory.toLowerCase() == "fraud")
      
      // this.rulesData = this.dummyRules;
    }

    if (Array.isArray(this.rulesData) && this.rulesData.length > 0) {
      this.ruleCategories = this.rulesData.map(r => r.ruleCategory || r.category).filter((v, i, a) => a.indexOf(v) === i);
      this.getRuleCategoryUIFilter(this.ruleCategories);
      this.rulesDataFiltered = this.IO ? this.rulesData.filter(x =>  x.decision && x.decision.toLowerCase() !="approve") || [] : [];
      this.rulesPassedCount = this.rulesData.filter(x => x.decision && x.decision.toLowerCase() == "approve").length;
      this.rulesFailedCount = this.rulesData.filter(x => x.decision && x.decision.toLowerCase() != "approve").length;
      this.rulesRejectCount = this.rulesData.filter(x => x.decision && x.decision.toLowerCase() == "reject").length;
      this.rulesReferedCount = this.rulesData.filter(x => x.decision && x.decision.toLowerCase() == "refer").length;
    }
  }

  getRuleCategoryUIFilter(ruleCategories) {
    if (this.commonUtilty.isArrayIterable(ruleCategories)) {
      for (let i = 0; i < ruleCategories.length; i++) {
        if(ruleCategories[i]){
          let text = ruleCategories[i].toLowerCase();
        let formattedText = text ? text.charAt(0).toUpperCase() + text.slice(1) : '';
        let category = { text: formattedText, value: ruleCategories[i] };
        this.listOfCategories.push(category);
        }
        
      }
    }
  }


  parentEvent$
  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.fraudRulePingSubject$.subscribe((param: any) => {
      
      let isOutputValid = true
      if (isOutputValid) {
        let array = ['ABC']
        this.EmitComponentOutput(array);
        /*Test code */
        this.parentEvent$.unsubscribe()
      }
      else {
        this.EmitComponentOutput("ERROR")
      }
    })

  }
  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  filterRulesOnCategory(filterArray) {
    if (this.commonUtilty.isArrayIterable(filterArray)) {
      for (let fl = 0; fl < filterArray.length; fl++) {
        this.rulesDataFiltered = this.rulesData.filter(item => item.ruleCategory === filterArray[fl]);
      }
    } else {
      this.rulesDataFiltered = this.rulesData.filter(x => x.decision);
    }
  }

  

  reset(): void {
    this.searchValue = '';
    this.rulesDataFiltered = this.rulesData.filter(x => x.decision);
  }

  searchRules(value) {
    if (value) {
      this.rulesDataFiltered = this.rulesData.filter(item => item.ruleName ? item.ruleName.toLowerCase().includes(value.toLowerCase()) : false);
    }
  }

}
